import TYPES from '../../types';

// Domain
import {
  CustomerInvestorGoalReminderEntity,
} from '@/modules/flagship/customer-investor-goal-reminder/domain/entities/customer-investor-goal-reminder-entity';
import {
  CustomerInvestorGoalReminderRepository,
} from '@/modules/flagship/customer-investor-goal-reminder/domain/repositories/customer-investor-goal-reminder-repository';
import {
  CustomerInvestorGoalReminderStateManager,
} from '@/modules/flagship/customer-investor-goal-reminder/domain/state/customer-investor-goal-reminder-state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Command from '@/modules/shared/domain/use-cases/command';

@Injectable()
export default class UpdateCustomerInvestorGoalReminderCommand
  extends Command<CustomerInvestorGoalReminderEntity> {
  @Inject(TYPES.CUSTOMER_INVESTOR_GOAL_REMINDER_STATE_MANAGER)
  private readonly state_manager!: CustomerInvestorGoalReminderStateManager;

  @Inject(TYPES.CUSTOMER_INVESTOR_GOAL_REMINDER_REPOSITORY)
  private readonly repository!: CustomerInvestorGoalReminderRepository;

  internalExecute(customer_investor_goal_reminder_entity: CustomerInvestorGoalReminderEntity):
    Promise<void> {
    return new Promise((resolve, reject) => {
      this.repository.update(customer_investor_goal_reminder_entity)
        .then(() => {
          this.state_manager.patch({ items: customer_investor_goal_reminder_entity, loaded: true });
          resolve();
        })
        .catch(reject);
    });
  }
}
